export { Tabs } from './Tabs'
export type { TabItem } from './Tabs'
